import {React, useState, useEffect} from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css'; // استایل‌های پیش‌فرض Swiper
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Row, Col } from "react-bootstrap";
import UseMediaQuery from "./UseMediaQuery";


import slider1 from '../img/slider/slider1.jpg';
import slider2 from '../img/slider/slider2.jpg';
import slider3 from '../img/slider/slider3.jpg';
import slider4 from '../img/slider/slider4.jpg';
import slider5 from '../img/slider/slider5.jpg';
/*import slider6 from '../img/slider/slider6.jpeg';
import slider7 from '../img/slider/slider7.jpeg';
import slider8 from '../img/slider/slider8.jpeg';*/

import slidermobile1 from '../img/slider/slider-mobile1.jpg';
import slidermobile2 from '../img/slider/slider-mobile2.jpg';
import slidermobile3 from '../img/slider/slider-mobile3.jpg';
import slidermobile4 from '../img/slider/slider-mobile4.jpg';
import slidermobile5 from '../img/slider/slider-mobile5.jpg';
/*import slidermobile6 from '../img/slider/slider-mobile6.jpeg';
import slidermobile7 from '../img/slider/slider-mobile7.jpeg';
import slidermobile8 from '../img/slider/slider-mobile8.jpeg';*/

const desktopImages = [slider1, slider2, slider3, slider4,slider5];
const mobileImages = [slidermobile1, slidermobile2, slidermobile3, slidermobile4,slidermobile5];

const Slider = () => {
    const isMobile = UseMediaQuery("(max-width: 768px)");

    return (
        <Swiper
       modules={[Autoplay]}
        slidesPerView={1}
        //pagination={{ clickable: true }}
        loop
         speed={3000}
        autoplay={{
            delay: 6000, // زمان بین هر اسلاید به میلی‌ثانیه
            disableOnInteraction: false, // اگر کاربر با اسلایدر تعامل داشت، ادامه بده
        }}
        >   

             {desktopImages.map((desktopImage, index) => {
                const mobileImage = mobileImages[index];
                const currentImage = isMobile ? mobileImage : desktopImage;

                // برای اسلاید اول، محتوای خاص داریم
               
                    return (
                        <SwiperSlide key={index}>
                            <div className="banner-i" style={{ backgroundImage: `url(${currentImage})` }}>
                                {index === 2 &&
                                <Row className="justify-content-center text-center mt-4">
                                    <Col>
                                    <br/>
                                        <h1 className="title-banner">کیمیا گالری</h1>
                                        <p className="drc-banner">کلیه محصولات گالری کیمیا طلای 18 عیار می باشد.</p>
                                    </Col>
                                </Row>
                                }
                            </div>
                        </SwiperSlide>
                    );
            })}
        
        </Swiper>
    );
};

export default Slider;